<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="订单编号：">
            <el-input v-model="query.orderNo" placeholder="请输入订单编号" clearable size="small" />
          </el-form-item>
          <el-form-item label="用户姓名：">
            <el-input v-model="query.customerName" placeholder="请输入用户姓名" clearable size="small" />
          </el-form-item>
          <el-form-item label="用户手机号：">
            <el-input v-model="query.customerPho" placeholder="请输入用户机号" clearable size="small" />
          </el-form-item>
          <el-form-item label="用户身份：">
            <el-select v-model="query.customerCLevel" placeholder="请选择" clearable size="small">
              <el-option v-for="(item,index) in options.standingList" :label="item.name" :value="item.level" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="技术老师姓名：">
            <el-input v-model="query.technicianInfoRealName" placeholder="请输入老师姓名" clearable size="small" />
          </el-form-item>
          <el-form-item label="技术老师手机号：">
            <el-input v-model="query.technicianInfoMobile" placeholder="请输入老师手机号" clearable size="small" />
          </el-form-item>
          <el-form-item label="老师身份：">
            <el-select v-model="query.technicianInfoLevelId" placeholder="请选择" clearable size="small">
              <el-option v-for="(item,index) in options.technicalServiceLevel" :key="index" :label="item.value" :value="item.key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="预约类型：">
            <el-select v-model="query.type" placeholder="请选择" clearable size="small">
              <el-option label="线上服务" :value="20"></el-option>
              <el-option label="线下服务" :value="10"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="服务类型：">
            <el-select v-model="query.serviceItems" placeholder="请选择" clearable size="small">
              <el-option v-for="(item,index) in options.configList" :key="index" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="取消类型：">
            <el-select v-model="query.cancelType" placeholder="请选择" clearable size="small">
              <el-option label="本人取消" :value="10"></el-option>
              <el-option label="老师取消" :value="11"></el-option>
              <el-option label="后台取消" :value="20"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间筛选：">
            <el-select v-model="query.isEnable" placeholder="请选择" clearable size="small">
              <el-option label="排期时间" :value="1"></el-option>
              <el-option label="提交预约时间" :value="2"></el-option>
              <el-option label="签到时间" :value="3"></el-option>
              <el-option label="评论时间" :value="4"></el-option>
              <el-option label="取消时间" :value="5"></el-option>
            </el-select>
            <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <el-tabs v-model="activeName" @tab-click="doQueryList({pageNo:1})">
          <el-tab-pane label="待排期" name="10">待排期</el-tab-pane>
          <el-tab-pane label="待服务" name="20">待服务</el-tab-pane>
          <el-tab-pane label="待评论" name="30">待评论</el-tab-pane>
          <el-tab-pane label="已完成" name="40">已完成</el-tab-pane>
          <el-tab-pane label="已取消" name="50">已取消</el-tab-pane>
        </el-tabs>
        <div class="btn-box">
          <el-button type="primary" size="mini" @click="handleDownload" plain v-hasPermi="['technical:reservation:export']">导出</el-button>
          <!-- <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus">添加老师</el-button> -->
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" :key="activeName">
        <el-table-column type="selection" width="50" />
        <el-table-column label="订单编号" prop="orderNo" align="center" fixed width="180">
          <template slot-scope="{row}">
            <div @click="handleShow(row)">
              <el-link type="primary">{{row.orderNo}}</el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="`${activeName=='10'?'预约':''}用户信息`" prop="" align="center" width="160" fixed>
          <template slot-scope="{row}">
            {{row.customerName}}({{row.customerLevelName}})<br />
            {{row.customerPho}}
          </template>
        </el-table-column>
        <el-table-column label="技术老师信息" prop="" align="center" width="200">
          <template slot-scope="{row}">
            {{row.technicianInfoRealName}}({{row.technicianInfoLevelName}})<br />
            {{row.technicianInfoMobile}}
          </template>
        </el-table-column>
        <el-table-column label="预约类型" prop="type" align="center">
          <template slot-scope="{row}">
            {{row.type==10?'线下服务':'线上服务'}}
          </template>
        </el-table-column>
        <el-table-column label="服务类型" prop="serviceItems" align="center" />
        <el-table-column label="地址" prop="address" align="center" width="200">
          <template slot-scope="{row}">
            {{row.provinceName}}{{row.cityName}}{{row.districtName}}{{row.address}}
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="message" align="center" />
        <el-table-column label="转单次数" prop="changeServiceTechCount" align="center" />
        <el-table-column label="排期时间" prop="startTime" sortable align="center" width="230" v-if="activeName!='10'">
          <template slot-scope="{row}">
            {{row.startTime}}-{{row.endTime?row.endTime.split(' ')[1]:''}}
          </template>
        </el-table-column>
        <el-table-column label="提交预约时间" prop="createdTime" sortable align="center" width="200">
          <template slot-scope="{row}">
            {{row.createdTime}}
          </template>
        </el-table-column>
        <el-table-column label="签到时间" prop="signInTime" sortable align="center" width="200" v-if="['30','40'].includes(activeName)" />
        <el-table-column label="评论时间" prop="completeTime" current-row-key="completeTime" sortable align="center" width="200" v-if="activeName=='40'" />
        <el-table-column label="地址" prop="signInAddress" current-row-key="signInAddress" align="center" width="200" v-if="activeName=='30'">
        </el-table-column>
        <el-table-column label="签到备注" prop="signInRemark" align="center" current-row-key="signInRemark" width="200" v-if="activeName=='30'" />
        <el-table-column label="签到图片" prop="signInTime" align="center" current-row-key="signInTime" width="200" v-if="activeName=='30'">
          <template slot-scope="{row}">
            <div v-if="row.signInImageUrls">
              <el-image style="width: 50px; height: 50px;border-radius: 4px;" class="mr10" :src="it" :preview-src-list="[row.signInImageUrls.split(',')]" v-for="(it,indexs) in row.signInImageUrls.split(',')" :key="indexs"></el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="取消时间" prop="cancelTime" current-row-key="cancelTime" sortable align="center" width="200" v-if="activeName=='50'" />
        <el-table-column label="取消类型" prop="cancelType" current-row-key="cancelType" align="center" width="200" v-if="activeName=='50'">
          <template slot-scope="{row}">
            {{row.cancelType==10?'本人取消':row.cancelType==11?'老师取消':'后台取消'}}
          </template>
        </el-table-column>
        <el-table-column label="取消原因" prop="cancelReason" current-row-key="cancelReason" align="center" width="200" v-if="activeName=='50'" />
        <el-table-column label="操作时间" prop="operatedTime" current-row-key="operatedTime" align="center"  />
        <el-table-column label="操作人" prop="operatedName" current-row-key="operatedName" align="center"  />
        <el-table-column label="操作" align="center" fixed="right" width="270px">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleCancel(row)" v-if="['10','20'].includes(activeName)" v-hasPermi="['technical:reservation:cancel']">取消订单</el-button>
            <el-button type="text" @click="handleUpdate(row,0)" v-if="activeName=='10'" v-hasPermi="['technical:reservation:schedul']">排期</el-button>
            <el-button type="text" @click="handleTransfer(row)"  v-if="['10','20'].includes(activeName)" >转单</el-button>
            <el-button type="text" @click="handleUpdate(row,1)" v-if="activeName=='20'" v-hasPermi="['technical:reservation:time']">调整预约时间</el-button>
            <el-button type="text" @click="handleUpdate(row,5)">日志记录</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <!-- <technicalManage-add ref="technicalManageAdd" @created="doQueryList({})" :technicalServiceLevel="options.technicalServiceLevel" :popType="popType"/> -->
    <cancel-dialog ref="reservationQuit" @created="doQueryList({})" />
    <edit-dialog ref="reservationEdit" @created="doQueryList({})" />
    <transfer-dialog ref="transferDialog" @created="doQueryList({})" />
  </div>
</template>

<script>
import technicianServiceOrderApi from '@/api/technical/technicianServiceOrder'
import technicalServiceLevelApi from '@/api/sys/technicalServiceLevel'
import customerLevelApi from '@/api/sys/customerLevel'
import sysDataconstantApi from '@/api/config/sysDataconstant'
import cancelDialog from './cancelDialog'
import editDialog from './editDialog'
import transferDialog from './transfer'
export default {
  components: {
    cancelDialog,
    editDialog,
    transferDialog
    // technicalAdjust
  },
  data() {
    return {
      // type 服务类型 10 线下服务 20 线上服务
      // cancelType 取消类型 10用户取消 11技术老师取消20后台取消
      popType: 0, //0:新增 1:编辑 2:修改身份 3:团队调整-添加老师 4:调整上级 5调整区域 6 设为在职 7：客户调整
      cascaderProps: {
        label: 'regionName',
        value: 'regionCode',
        children: 'child',
        // value: 'value',
      },
      dateTime: null,
      areaArr: [],
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        // name: undefined,
        // isEnable: undefined,
      },
      selectItems: [],
      activeName: '10',
      options: {
        technicalServiceLevel: [],
        standingList: [],
        configList: []
      },
      regionOptions: []
    }
  },
  created() {
    this.regionOptions = JSON.parse(localStorage.getItem('addressTree')) || [];
    // this.regionOptions = regionOptions[0].children
    technicalServiceLevelApi.findOptions().then(({
      data
    }) => {
      this.options.technicalServiceLevel = data
    })
    this.doQueryList({
      pageNo: 1
    })
    this.getStandingList()
    this.getConfig()
  },
  methods: {
    handleTransfer(row) {
      this.$refs.transferDialog.handleUpdate(row)
    },
    handleFilter() {
      this.query = {
        pageNo: 1,
        pageSize: 10
      }
      this.dateTime = []
      this.doQueryList({
        pageNo: 1
      })
    },
    /**
     * 列表tab切换
     */
    handleClick() {
      console.log('val: ', this.activeName);
    },
    // 获取客户身份
    getStandingList() {
      customerLevelApi.fetchList({
        type: 3
      }).then(({
        data
      }) => {
        this.options.standingList = data
        // console.log('客户身份: ',data);
      })
    },
    // 获取系统配置
    getConfig() {
      sysDataconstantApi.fetchBatchCode({
        code: 'appointmentServiceItems'
      }).then(({
        data
      }) => {
        this.options.configList = data.list[0].content.split(',')
        // console.log("配置: ", data);
      })
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({
        pageNo: 1
      })
    },
    clacPrams() {
      // this.query.provinceCode = this.areaArr && this.areaArr.length ? this.areaArr[0] : undefined
      // this.query.cityCode = this.areaArr && this.areaArr.length ? this.areaArr[1] : undefined
      // this.query.districtCode = this.areaArr && this.areaArr.length ? this.areaArr[2] : undefined
      this.query.status = this.activeName
    },
    doQueryList({
      pageNo,
      pageSize
    }) {
      this.list = []
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.clacPrams()
      let query = {
        ...this.query
      }
      if (this.activeName == 30) {
        query.isComment = 0
      }
      if (this.activeName == 40) {
        query.status = 30
        query.isComment = 1
      }
      if (this.dateTime && this.dateTime.length) {
        if (this.query.isEnable == 1) {
          query.startTime = this.dateTime[0]
          query.endTime = this.dateTime[1]
        }
        if (this.query.isEnable == 2) {
          query.createdTimeStart = this.dateTime[0]
          query.createdTimeEnd = this.dateTime[1]
        }
        if (this.query.isEnable == 3) {
          query.signInTimeStart = this.dateTime[0]
          query.signInTimeEnd = this.dateTime[1]
        }
        if (this.query.isEnable == 4) {
          query.completeTimeStart = this.dateTime[0]
          query.completeTimeEnd = this.dateTime[1]
        }
        if (this.query.isEnable == 5) {
          query.cancelTimeStart = this.dateTime[0]
          query.cancelTimeEnd = this.dateTime[1]
        }
      }
      delete query.isEnable
      this.listLoading = true
      return technicianServiceOrderApi.fetchList(query)
        .then(data => {
          console.log('data-0---: ', data);
          this.list = data.data.list
          this.total = data.data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    // 取消预约
    handleCancel(row) {
      this.$refs.reservationQuit.handleUpdate({
        id: row.id
      })
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => technicianInfoApi.deleteById(row.id))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({
            pageNo: 1
          })
        })
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择角色')
        return
      }
      return this.$common.confirm('是否确认删除')
        .then(() => technicianInfoApi.deleteBatch(this.selectItems.map(row => row.id)))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({
            pageNo: 1
          })
        })
    },
    beforeHandleCommand(row, command) {
      return {
        'row': row,
        'command': command
      }
    },
    handleCommand(command) {
      // console.log(command,'11111111')
      this.popType = command.command
      //离职
      if (command.command === 1) {
        // this.$common.confirm('是否确认提交离职，离职后该老师无法享受技术老师权益')
        //   .then(() => this.$refs.technicalQuit.handleQuit(command.row))
        this.$refs.technicalQuit.handleQuit(command.row)
      } else if ([2, 5, 4].includes(command.command)) {

        this.$refs.technicalManageAdd.handleUpdate(command)
        // this.handleBatchState(ids, 2)
      } else if ([3, 7].includes(command.command)) {
        this.$refs.technicalAdjust.handleUpdate(command)
      } else if (command.command == 5) {
        this.$router.push("/log/log?type=22&id=" + command.row.id);
      }
      // else if(command.command === 3){

      // }else if(command.command === 4){
      //   // this.popType=4
      //   this.$refs.technicalManageAdd.handleUpdate(command)
      // }
    },
    changeSwitch(row) {
      technicianInfoApi.setIsEnable({
        id: row.id,
        isEnable: row.isEnable
      }).then(() => {
        this.$common.showMsg('success', '操作成功')
      })
    },
    uploadFile(file) {
      let formData = new FormData();
      formData.append("file", file.file);
      technicianInfoApi.getImport(formData).then(res => {
        if (res.code === '0') {
          this.$message.success(res.msg || '操作成功')
          this.doQueryList({})
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    /**
     * 打开新建表单
     */
    handleCreate(row) {
      this.popType = 0
      // this.$refs.technicalManageAdd.handleCreate(row)
    },
    /**
     * 打开查看表单
     */
    handleShow(row) {
      this.$emit('handleShow', row.id, 2)
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row, type) {
      // console.log('type: ',type);
      // this.popType=type
      if (type == 5) {
        this.$router.push("/log/log?type=22&id=" + row.id);
      } else {
        this.$refs.reservationEdit.handleUpdate({
          row,
          type
        })
      }

    },
    handleDownload() {
      this.$router.push("/export/list?code=EEForTechServiceOrder")
    },
  }
}
</script>
